import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';
import { SearchInput } from '@abyss/web/ui/SearchInput';

export const StyledLocationSearch = styled(SearchInput, {
  '.abyss-search-input-input': {
    boxShadow: 'none',
    border: 'none',
    fontSize: '18px !important',
    color: '#4B4D4F',
    fontWeight: '500',
  },
  '&.abyss-search-input-root': {
    border: '1px solid',
    borderRadius: '4px',
  },
  '.abyss-search-input-input-container': {
    alignItems: 'left',
    border: 'none',
  },
  '.abyss-search-input-section': {
    backgroundColor: '$white',
    color: '$gray6',
    fontWeight: '$medium',
  },
  '.abyss-search-input-icon-container': {
    display: 'none',
  },
  '.abyss-search-input-option-icon': {
    display: 'none',
  },
  '&.abyss-search-input-option-list': {
    border: '1px solid $gray4',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
    maxHeight: '500px',
  },
  '&.abyss-search-input-option-list:has(> .abyss-search-input-no-options)': {
    border: 'none',
    boxShadow: 'none',
    display: 'none',
  },
  '.abyss-search-input-left-element-wrapper': {
    width: '24px !important',
    zIndex: 0,
  },

  variants: {
    isLocationModal: {
      true: {
        '&.abyss-search-input-option-list': {
          borderLeft: '2px solid $interactive1',
          borderRight: '2px solid $interactive1',
          borderBottom: '2px solid $interactive1',
          borderTop: '1px solid $gray4',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
          maxHeight: '500px',
          maxWidth: 'auto',
          width: '408px',
          marginLeft: '-21.9px',
          marginTop: '8px',
        },
      },
    },
  },
});

export const StyledLocationHeader = styled(Layout.Stack, {
  marginLeft: '4px',
  color: '#323334',
  fontSize: '14.22px',
  fontWeight: '$bold',
  '&.abyss-layout-stack': {
    alignItems: 'flex-start',
    'div:nth-of-type(2)': {
      position: 'relative',
      top: '8px',
    },
  },
});

export const StyledLocationItems = styled(Layout.Stack, {
  marginLeft: '2px',
});

export const StyledLocationError = styled(Layout.Group, {
  '.error-message, div:first-child': {
    width: '20px !important',
  },
});

export const FindUserLocationContainer = styled(Flex, {
  alignItems: 'center',
  height: '40px',
});
